import * as types from "../constants/actionTypes";
import initialstate from "./initialState";

export const registrationData = (
  state = initialstate.registrationData,
  action
) => {
  switch (action.type) {
    case types.SET_REGISTRATION_DATA:
      return action.payload;
    case types.GET_CLUB_LOGGED_SUCCESS:
    case types.CLUB_USER_LOGIN:
      return {
        ...state
      };
    case types.GET_CLUB_LOGGED_FAIL:
    case types.CLUB_USER_LOGOUT:
      return state;
    default:
      return state;
  }
};

export const totalAmountToPay = (state = null, action) => {
  switch (action.type) {
    case types.SET_TOTAL_AMOUNT_TO_PAY:
      return action.payload;
    default:
      return state;
  }
};

export const totalClubAmountToPay = (state = null, action) => {
  switch (action.type) {
    case types.SET_TOTAL_CLUB_AMOUNT_TO_PAY:
      return action.payload;
    default:
      return state;
  }
};

export const orderCurrency = (state = {}, action) => {
  switch (action.type) {
    case types.SET_ORDER_CURRENCY:
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/registrationReducer.js